/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";

// Developer-only copy review, like the debug bar it is toggled from: the bar's
// ERRORS switch, or ?showErrors=1 / ?showErrors=0, remembered in localStorage.
// While on, every error slot renders every message that can appear in it, each
// tagged with its locale key. Deliberately not localised — it is a tool.
export const SHOW_ERRORS = (() => {
  try {
    const param = new URLSearchParams(window.location.search).get("showErrors");
    if (param === "1") window.localStorage.setItem("plugShowErrors", "1");
    if (param === "0") window.localStorage.removeItem("plugShowErrors");
    return window.localStorage.getItem("plugShowErrors") === "1";
  } catch (e) {
    return false;
  }
})();

// The debug bar's toggle. SHOW_ERRORS is read once at load, so flipping it
// reloads the page rather than threading a live flag through every component.
export const setShowErrors = (on) => {
  try {
    if (on) window.localStorage.setItem("plugShowErrors", "1");
    else window.localStorage.removeItem("plugShowErrors");
  } catch (e) {
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.delete("showErrors");
  window.location.assign(url.toString());
};

const lookup = (m, key) =>
  key.split(".").reduce((d, k) => (d && typeof d === "object" ? d[k] : undefined), m);

const tagStyle = {
  display: "inline-block",
  marginLeft: 8,
  padding: "0 5px",
  font: "11px ui-monospace, monospace",
  background: "#ffe14d",
  color: "#222",
  borderRadius: 3,
  verticalAlign: "middle",
};

// One element per message, in the slot's own className so it sits and looks
// exactly as the real error would.
export const ErrorPreview = ({ m, keys, className, style, fill }) =>
  keys.map((key) => {
    let text = lookup(m, key);
    text = typeof text === "string" ? text : "⚠ missing: " + key;
    if (fill) {
      Object.keys(fill).forEach((k) => (text = text.split("{" + k + "}").join(fill[k])));
    }
    return (
      <div className={className} style={Object.assign({ outline: "2px dashed #ffb400" }, style)} key={key}>
        {text}
        <span style={tagStyle}>{key}</span>
      </div>
    );
  });
